












































import { defineComponent, computed, ref } from '@vue/composition-api'
import ComparisonPlanTableParts from '@/components/common/MembershipPlan/ComparisonPlanTableParts.vue'
import AtomLink from '@/components/atoms/AtomLink.vue'
import DeviceInfo from '@/util/DeviceInfo'
import Const from '@/util/Const'
import I18n from '@/locales/I18n'
import FreeTrialNoticeParts from '@/components/SignupPage/common/FreeTrialNoticeParts.vue'
import AtomButton from '@/components/atoms/AtomButton.vue'
import ComparisonPlanModalSection from '@/components/common/MembershipPlan/ComparisonPlanModalSection.vue'

/**
 * 新規会員登録 プラン比較
 */
export default defineComponent({
  name: 'ComparisonPlanSection',
  components: {
    ComparisonPlanModalSection,
    AtomButton,
    FreeTrialNoticeParts,
    ComparisonPlanTableParts,
    AtomLink,
  },
  props: {
    /**
     * 表示するタイトル
     */
    sectionTitle: {
      type: String,
      default: '',
    },
    /**
     * 無料トライアルのお知らせを表示するかどうか
     */
    showTrialNotice: {
      type: Boolean,
      default: false,
    },
    /**
     * トライアル広告ページかどうか
     */
    isTrialAds: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // 機能比較表モーダルを表示するかどうか
    const showPlanModal = ref(false)

    // SFgo公式サイトへのリンクを表示するかどうか
    const isAndroid = computed(() => DeviceInfo.isAndroid())

    const officialSFgoLink =
      I18n.locale === 'ja' ? Const.EXTERNAL_LINKS.ABOUT_SFGO.JA : Const.EXTERNAL_LINKS.ABOUT_SFGO.EN

    // 使用端末がアプリかどうか
    const isForApp = computed(() => DeviceInfo.isiOS() || DeviceInfo.isAndroid())

    /**
     * プラン比較表をモーダルで表示するかどうか
     * トライアル広告の場合、下の部分の高さが出てしまう。その影響でスマホだと表示領域が狭くなるため、トライアル広告 かつ スマホの場合はモーダルで表示する。
     */
    const isDisplayComparisonPlanInModal = computed(
      () => props.isTrialAds && DeviceInfo.isSmartPhone(),
    )

    return {
      showPlanModal,
      isAndroid,
      officialSFgoLink,
      isForApp,
      isDisplayComparisonPlanInModal,
    }
  },
})
